import { action } from 'typesafe-actions'
import { CourseRecomActionTypes } from './types'
import { ICourseRecom } from '../interface'

export const fetchRequest = (searchParams:any) => {
   //console.log("fetchRequest: " + searchParams.searchTerm);
   return action(CourseRecomActionTypes.FETCH_REQUEST, searchParams);
}

export const fetchSuccess = (data: ICourseRecom[]) => action(CourseRecomActionTypes.FETCH_SUCCESS, data)
export const selectCourse = (id: string) => action(CourseRecomActionTypes.SELECT, id)
export const courseSelected = (data: ICourseRecom) => action(CourseRecomActionTypes.SELECTED, data)
export const fetchError = (message: string) => action(CourseRecomActionTypes.FETCH_ERROR, message)
